import { ColorPalette } from '@optimus-web/local-tokens';
import { BasicColorScale, ColorScale } from './types';

export const blue: ColorScale = {
    50: ColorPalette.COLOR_INDIGO_100,
    100: ColorPalette.COLOR_INDIGO_200,
    200: ColorPalette.COLOR_INDIGO_200,
    300: ColorPalette.COLOR_INDIGO_300,
    400: ColorPalette.COLOR_INDIGO_400,
    base: ColorPalette.COLOR_INDIGO_500,
    700: ColorPalette.COLOR_INDIGO_600,
    800: ColorPalette.COLOR_INDIGO_800,
    900: ColorPalette.COLOR_INDIGO_900,
};

export const blueDark: ColorScale = {
    50: ColorPalette.COLOR_INDIGO_100,
    100: ColorPalette.COLOR_INDIGO_100,
    200: ColorPalette.COLOR_INDIGO_100,
    300: ColorPalette.COLOR_INDIGO_100,
    400: ColorPalette.COLOR_INDIGO_200,
    base: ColorPalette.COLOR_INDIGO_300,
    700: ColorPalette.COLOR_INDIGO_400,
    800: ColorPalette.COLOR_INDIGO_500,
    900: ColorPalette.COLOR_INDIGO_600,
};

export const infoBlue: ColorScale = {
    50: ColorPalette.COLOR_BLUE_100,
    100: ColorPalette.COLOR_BLUE_200,
    200: ColorPalette.COLOR_BLUE_300,
    300: ColorPalette.COLOR_BLUE_400,
    400: ColorPalette.COLOR_BLUE_500,
    base: ColorPalette.COLOR_BLUE_600,
    700: ColorPalette.COLOR_BLUE_700,
    800: ColorPalette.COLOR_BLUE_800,
    900: ColorPalette.COLOR_BLUE_900,
};

export const infoBlueDark: ColorScale = {
    50: ColorPalette.COLOR_BLUE_100,
    100: ColorPalette.COLOR_BLUE_100,
    200: ColorPalette.COLOR_BLUE_200,
    300: ColorPalette.COLOR_BLUE_300,
    400: ColorPalette.COLOR_BLUE_400,
    base: ColorPalette.COLOR_BLUE_500,
    700: ColorPalette.COLOR_BLUE_600,
    800: ColorPalette.COLOR_BLUE_700,
    900: ColorPalette.COLOR_BLUE_800,
};

export const green: ColorScale = {
    50: ColorPalette.COLOR_GREEN_100,
    100: ColorPalette.COLOR_GREEN_200,
    200: ColorPalette.COLOR_GREEN_300,
    300: ColorPalette.COLOR_GREEN_400,
    400: ColorPalette.COLOR_GREEN_500,
    base: ColorPalette.COLOR_GREEN_800,
    700: ColorPalette.COLOR_GREEN_800,
    800: ColorPalette.COLOR_GREEN_800,
    900: ColorPalette.COLOR_GREEN_900,
};

export const greenDark: ColorScale = {
    50: ColorPalette.COLOR_GREEN_100,
    100: ColorPalette.COLOR_GREEN_100,
    200: ColorPalette.COLOR_GREEN_300,
    300: ColorPalette.COLOR_GREEN_300,
    400: ColorPalette.COLOR_GREEN_400,
    base: ColorPalette.COLOR_GREEN_500,
    700: ColorPalette.COLOR_GREEN_600,
    800: ColorPalette.COLOR_GREEN_700,
    900: ColorPalette.COLOR_GREEN_800,
};

export const red: ColorScale = {
    50: ColorPalette.COLOR_RED_100,
    100: ColorPalette.COLOR_RED_200,
    200: ColorPalette.COLOR_RED_300,
    300: ColorPalette.COLOR_RED_400,
    400: ColorPalette.COLOR_RED_500,
    base: ColorPalette.COLOR_RED_600,
    700: ColorPalette.COLOR_RED_700,
    800: ColorPalette.COLOR_RED_800,
    900: ColorPalette.COLOR_RED_900,
};

export const redDark: ColorScale = {
    50: ColorPalette.COLOR_RED_100,
    100: ColorPalette.COLOR_RED_200,
    200: ColorPalette.COLOR_RED_200,
    300: ColorPalette.COLOR_RED_300,
    400: ColorPalette.COLOR_RED_400,
    base: ColorPalette.COLOR_RED_500,
    700: ColorPalette.COLOR_RED_600,
    800: ColorPalette.COLOR_RED_700,
    900: ColorPalette.COLOR_RED_800,
};

export const orange: ColorScale = {
    50: ColorPalette.COLOR_YELLOW_100,
    100: ColorPalette.COLOR_YELLOW_200,
    200: ColorPalette.COLOR_YELLOW_200,
    300: ColorPalette.COLOR_YELLOW_300,
    400: ColorPalette.COLOR_YELLOW_400,
    base: ColorPalette.COLOR_YELLOW_500,
    700: ColorPalette.COLOR_YELLOW_600,
    800: ColorPalette.COLOR_YELLOW_800,
    900: ColorPalette.COLOR_YELLOW_900,
};

export const orangeDark: ColorScale = {
    50: ColorPalette.COLOR_YELLOW_100,
    100: ColorPalette.COLOR_YELLOW_200,
    200: ColorPalette.COLOR_YELLOW_200,
    300: ColorPalette.COLOR_YELLOW_300,
    400: ColorPalette.COLOR_YELLOW_400,
    base: ColorPalette.COLOR_YELLOW_500,
    700: ColorPalette.COLOR_YELLOW_600,
    800: ColorPalette.COLOR_YELLOW_700,
    900: ColorPalette.COLOR_YELLOW_800,
};

export const neutral: BasicColorScale = {
    25: ColorPalette.COLOR_NIGHT_100,
    50: ColorPalette.COLOR_NIGHT_200,
    100: ColorPalette.COLOR_NIGHT_300,
    200: ColorPalette.COLOR_NIGHT_400,
    300: ColorPalette.COLOR_NIGHT_500,
    400: ColorPalette.COLOR_NIGHT_600,
    base: ColorPalette.COLOR_NIGHT_700,
    700: ColorPalette.COLOR_NIGHT_800,
    800: ColorPalette.COLOR_NIGHT_900,
    900: ColorPalette.COLOR_NIGHT_900,
    1000: ColorPalette.COLOR_NIGHT_900,
};

export const neutralDark: BasicColorScale = {
    25: ColorPalette.COLOR_GREY_100,
    50: ColorPalette.COLOR_GREY_200,
    100: ColorPalette.COLOR_GREY_300,
    200: ColorPalette.COLOR_GREY_500,
    300: ColorPalette.COLOR_GREY_600,
    400: ColorPalette.COLOR_GREY_700,
    base: ColorPalette.COLOR_GREY_1000,
    700: ColorPalette.COLOR_GREY_1000,
    800: ColorPalette.COLOR_GREY_1000,
    900: ColorPalette.COLOR_GREY_1100,
    1000: ColorPalette.COLOR_GREY_1100,
};

export const black = ColorPalette.COLOR_NIGHT_900;
export const white = ColorPalette.COLOR_NIGHT_0;
